export default "__VITE_ASSET__D8ri3nGd__"